import { Component, Input } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'xp-icon',
  template: `
    <div class="base-icon">
      <i class="fa fa-{{ type }}"></i>
    </div>
  `,
})
export class XpIconComponent {
  @Input() type: string;
}

((window as any).xplenty as angular.IModule).directive(
  'xpIcon',
  downgradeComponent({
    component: XpIconComponent,
  }),
);
